import script from "./AddNewOneDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AddNewOneDialog.vue?vue&type=script&setup=true&lang=js"

import "./AddNewOneDialog.vue?vue&type=style&index=0&id=2c482140&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c482140"]])

export default __exports__